module.exports = __webpack_public_path__ + "static/media/Frame 321.173a3f64.png";